import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";

export const getTutorInformationSuccess = (data) => {
  return {
    type: actionTypes.GET_TUTOR_INFORMATION,
    payload: {
      tutor: data.Data,
    },
  };
};

export const getTutorInformation = (data) => async (dispatch) => {
  return await apiCall
    .axiosPost(`${API_BASE_URL}/PrivateTutorInformation`, data)
    .then((response) => {
      if (response) {
        dispatch(getTutorInformationSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};